export default "__VITE_ASSET__CIv4mMYx__"